'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const utils$1 = require('./utils.js');
const rgba = require('./rgba.js');

function parseHex(v) {
  var r = '';
  var g = '';
  var b = '';
  var a = '';
  if (v.length > 5) {
    r = v.substr(1, 2);
    g = v.substr(3, 2);
    b = v.substr(5, 2);
    a = v.substr(7, 2);
  } else {
    r = v.substr(1, 1);
    g = v.substr(2, 1);
    b = v.substr(3, 1);
    a = v.substr(4, 1);
    r += r;
    g += g;
    b += b;
    a += a;
  }
  return {
    red: parseInt(r, 16),
    green: parseInt(g, 16),
    blue: parseInt(b, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
var hex = {
  test: utils$1.isColorString('#'),
  parse: parseHex,
  transform: rgba.rgba.transform
};

exports.hex = hex;
